$(document).ready(function () {
  console.log("hlo");
    $("img").each(function () {
        var src = $(this).attr("src");
        if (src && src.includes("56236666-84ee-4888-aa8d-6674e482c402.jpeg")) {
            $(this).attr("alt", "off-shoulder dress");
        }
    });
  
   $("span").each(function () {
        var spanText = $(this).text();
        if (spanText && spanText.includes("United States (USD $)")) {
            $(this).attr("style", "background-color:#ffffff !important; color:#000000 !important;font-size: 12px;");
        }
        /*else if (spanText.includes("Follow")) {
                  // Apply high contrast style
                  $(this).css({
                      "color": "#000000",             // Black text
                      "background-color": "#FFFFFF",  // White background
                      "font-size": "12px"             // Ensure readability
                  });
              }*/
    });

/*$("div").each(function () {
    var divText = $(this).text();

    if (!divText) return;

    // Normalize text for cleaner matching
    divText = divText.trim();

    const colors = ["Multi", "Champagne", "Pewter", "Blue", "Pink", "Gold", "Slate Blue"];

    for (let i = 0; i < colors.length; i++) {
        if (divText.includes(colors[i])) {
            $(this).css("font-size", "11px");

            break; // Stop once a match is found
        }
    }
});*/
});


 document.addEventListener('DOMContentLoaded', function () {
   
    setTimeout(function(){
    // Script for follow button inside shadow DOM
    function waitForFollowButton(callback) {
      const checkExist = setInterval(() => {
        const followButton = document.querySelector('shop-follow-button');
        if (followButton && followButton.shadowRoot) {
          clearInterval(checkExist);
          callback(followButton);
        }
      }, 200);
    }

    // Usage
    waitForFollowButton((followButton) => {
      const realBtn = followButton.shadowRoot.querySelector('button');
      if (realBtn) {
        realBtn.style.backgroundColor = '#2e00ff';
        realBtn.style.color = '#fff';
         console.log("Color updated");
      }
    });
    
    }, 2000); 
  });



  




